import { httpClient, HttpMethod } from './http-client';

export const getRegionTypes = (): any => {
  return httpClient('/regiontypes', HttpMethod.Get, null);
};